import styled from 'styled-components/native';
import { Feather as IconsFE, FontAwesome5 as IconsFA5 } from '@expo/vector-icons';
import { themes } from '../../../design/colors';
import Constants from 'expo-constants';

export const Container = styled.View`
    flex: 1;
`;

export const Content = styled.View`
    padding: 20px;
    margin-top: ${Constants.statusBarHeight + -150}px;
`;

export const Header = styled.View`
    background-color: ${themes.colors.primary};
    padding: ${Constants.statusBarHeight + 12}px 16px;
    flex-direction: row;
    justify-content: space-between;
    height: 200px;
`;

export const Title = styled.Text`
    color: ${themes.colors.white};
    font-size: 16px;
    font-weight: bold;
`;

export const IconFE = styled(IconsFE)``;

export const IconFA5 = styled(IconsFA5)``;

export const DateProblem = styled.Text`
  color: ${themes.colors.black2};
  font-size: 15px;
`;


export const TextProblem = styled.Text`
  color: ${themes.colors.black2};
  font-size: 15px;
`;


export const ContentProblem = styled.View`
  justify-content: space-between;
  flex-direction: row;
  background-color: ${themes.colors.white};
  padding: 20px;
  shadow-color: ${themes.colors.black};
  shadow-opacity: 0.23px;
  shadow-radius: 2.62px;
  elevation: 1px;
  border-radius: 5px;
  margin-bottom: 10px;
`;


export const NameProduct = styled.Text`
  color: ${themes.colors.white};
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 31px;
`;

export const Image = styled.Image`
  width: 100%;
  height: 200px;
  margin-bottom: 16px;
`;
